import logger from './logger';

const HEADERS_TO_REMOVE = [
  'host',
  'connection',
  'content-length',
  'transfer-encoding',
  'expect',
  'upgrade',
  'user-agent',
  'accept-encoding',
  'keep-alive',
  'proxy-authenticate',
  'proxy-authorization',
  'referer',
  'x-forwarded-for',
];

const sanitizeHeaders = headers => {
  if (!headers) {
    return undefined;
  }

  const sanitized = { ...headers };

  HEADERS_TO_REMOVE.forEach(header => {
    const lowerCaseKey = Object.keys(sanitized).find(key => key.toLowerCase() === header);
    if (lowerCaseKey) {
      delete sanitized[lowerCaseKey];
    }
  });

  return sanitized;
};

const fetchExternalHtml = async ({ url, headers }) => {
  try {
    const response = await fetch(url, {
      headers: sanitizeHeaders(headers),
      keepalive: true,
    });

    if (!response.ok) {
      throw new Error(`${response.statusText}`);
    }

    const html = await response.text();

    return {
      html,
    };
  } catch (error) {
    logger.error(`[fetchExternalHtml] error trying get ${url}`, error);
    return null;
  }
};

export default fetchExternalHtml;
